(function () {
  if (window.__tkHeurekaOptout) return;
  window.__tkHeurekaOptout = true;

  var pending = null;

  function updateUrl() {
    var url = (window.Theme && Theme.routes && Theme.routes.cart_update_url) || '/cart/update';
    return /\.js$/.test(url) ? url : url + '.js';
  }

  function send(value) {
    if (pending) pending.abort();
    var controller = new AbortController();
    pending = controller;
    fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { heureka_optout: value } }),
      signal: controller.signal
    })
      .catch(function () {})
      .then(function () {
        if (pending === controller) pending = null;
      });
  }

  function mirror(source) {
    var boxes = document.querySelectorAll('[data-tk-heureka-optout]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box !== source) box.checked = source.checked;
      var scope = box.closest('.checkbox');
      if (scope) scope.classList.toggle('tk-hs-checked', source.checked);
    }
  }

  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!(box instanceof HTMLInputElement) || !box.hasAttribute('data-tk-heureka-optout')) return;
    mirror(box);
    send(box.checked ? '1' : '');
  });
})();
